<template>
  <span>
    <img draggable="false" class="clickable" id="quit_btn_top" @click="goToStart()" src="./../../assets/images/Asset 58.png" alt="">
    <img draggable="false" class="background_image" src="./../../assets/images/kerstmis/Asset 48.png" alt="">
    <img draggable="false" id="kerstmis_bottom_image" src="./../../assets/images/kerstmis/Asset 61.png" alt="">
    <img draggable="false" @click="goToKerstmisMenu2()" class="clickable" id="kerst_play_btn" src="./../../assets/images/Asset 4.png" alt="">

    <span id="kerstmis_title_text">Hoe speel je dit?</span>
    <span id="kerstmis_description_text_1">Kies een kerstboom en maak jou eigen decoratie.</span>
    <span id="kerstmis_description_text_2">Sleep dan elk decoratie naar hou jij het wilt.</span>
    <span id="kerstmis_description_text_3">Klik op elk decoratie om te weten wat hun betekenis is.</span>
  </span>
</template>

<script>
export default {
  name: "KerstmisMenu1",
  mounted() {},

  created() {},
  destroyed() {},

  data() {
    return {};
  },

  methods: {
    goToStart() {
      this.$router.push('/kerstmis/start');
    },
    goToKerstmisMenu2() {
      this.$router.push('/kerstmis/menu/2');
    },
  },

  computed: {}
};
</script>

<style>
  #kerst_play_btn {
    position: absolute;
    margin-top: 32%;
    left: 40%;
    width: 20%;
  }
  #kerstmis_title_text {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 4%;
    width: 42%;
    left: 29%;
    color: #1b7537;
    font-size: 5vw;
    text-align: center;
    z-index: 1;
  }
  #kerstmis_description_text_1 {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 14%;
    width: 80%;
    left: 10%;
    color: #1b7537;
    font-size: 2.5vw;
    text-align: center;
    z-index: 1;
  }
  #kerstmis_description_text_2 {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 20%;
    width: 80%;
    left: 10%;
    color: #1b7537;
    font-size: 2.5vw;
    text-align: center;
    z-index: 1;
  }
  #kerstmis_description_text_3 {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 26%;
    width: 80%;
    left: 10%;
    color: #1b7537;
    font-size: 2.5vw;
    text-align: center;
    z-index: 1;
  }

  #kerstmis_bottom_image {
    font-family: 'LuckiestGuy';
    position: absolute;
    margin-top: 40%;
    width: 112%;
    left: -4%;
    color: #1b7537;
    font-size: 4.5vw;
    text-align: center;
    z-index: 0;
  }
</style>


